import { templateThemeTokens } from './templateThemeTokens.js';
import { fontStacks } from '@/stitches/fonts.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '$white',
    pageBackground: '#1f1f1f',
  },
  fonts: {
    body: fontStacks.switzer.value,
    heading: fontStacks.neco.value,
  },
});

export const midnight = createTheme({ ...mergedTokens });
